import { SERVICE } from '@src/constants';
import api from './api';

export const getUserPackages = async (params) => {
  const res = await api({
    method: 'GET',
    url: '/admin/user-packages',
    source: SERVICE.API_MANAGEMENT,
    params,
  });
  return res;
};
